module.exports = __webpack_public_path__ + "website/img/tab2.f89b9249.png";